/**
 * TEMPORARY name-matched candy photos.
 *
 * Ash's real photography (converted from the "Flavors_mixes pictures"
 * folder, 2026-09-22), used only as a fallback until real Shopify products
 * carry their own featured_image. Real product data always wins — see the
 * usage in pick-your-mix-ui.js's _renderGrid(). Delete this file and its
 * `candy-*.jpg` assets once every product has a real image assigned.
 */

const TEMP_CANDY_PHOTO_KEYS = [
  'ahlgrens', 'banana-toffee', 'blue-raspberry', 'bubs-big-sour', 'bubs-cola-skull',
  'bubs-pear', 'cola-chews', 'dizzy', 'fluffy-banana', 'grapefruit-bottle',
  'happy-chews', 'happy-flowers', 'hot-lips', 'lonka', 'mushroom', 'peach',
  'pineapple', 'pink-skulls', 'pomegranate', 'rambo-rainbow',
  'rambo-strawberry-cream-xl', 'rambo-twist', 'rambo-watermelon',
  'raspberry-licorice', 'sour-strawberry-banana', 'strawberry-belt',
  'strawberry-cream-mini', 'sugared-strawberry', 'swedish-skull', 'tutti-frutti',
  'watermelon-bombs', 'watermelon-skull', 'watermelon-slice', 'wild-berry-chews',
  'zoo-monkey',
];

function normalizeWords(str) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .split(' ')
    .filter((w) => w.length > 2);
}

function matchTempCandyPhoto(candyName) {
  const nameWords = new Set(normalizeWords(candyName));
  let best = null;
  let bestScore = 0;

  for (const key of TEMP_CANDY_PHOTO_KEYS) {
    const keyWords = normalizeWords(key.replace(/-/g, ' '));
    const shared = keyWords.filter((w) => nameWords.has(w)).length;
    const score = shared / keyWords.length;
    if (score > bestScore && shared > 0) {
      bestScore = score;
      best = key;
    }
  }

  // require at least half the key's words to match, so "Lonka Vanilla Fudge"
  // matches "lonka" but "Sour Belts Strawberry" doesn't loosely match "strawberry-belt"
  return bestScore >= 0.5 ? best : null;
}

window.matchTempCandyPhoto = matchTempCandyPhoto;
